import { State } from '@meraki-internal/state';

export class DrawerState extends State<{isOpen: boolean}> {

    private menu?: HTMLIonMenuElement;
    // Set when openMenu() ran before a usable menu element was registered — a drawer page's mount
    // effect fires before the parent drawer's ref attaches, so the request is honored on arrival.
    private pendingOpen = false;

    setIonMenu = (menu: HTMLIonMenuElement) => {
        this.menu = menu;
        if (this.pendingOpen) {
            this.pendingOpen = false;
            menu.open();
        }
    };

    // Opens THIS drawer's menu element rather than menuController.open('content-drawer'): the
    // global registry silently no-ops before the menu registers, and while a previous care-map
    // page instance is still alive in the router stack it can hold an older registration under
    // the same menuId — either way the visible drawer never presents while its route content
    // (mask + focused map) renders, leaving the map in a stuck half-open state.
    openMenu = () => {
        if (this.menu && this.menu.isConnected) {
            this.menu.open();
        } else {
            this.pendingOpen = true;
        }
    };

    setOpen = (isOpen: boolean) => {
        this.setState({ isOpen });
    };

    isOpen = () => {
        return Boolean(this.state?.isOpen);
    };
}


/**
 * More refactoring is needed such that all access to change the menu go through this class
 *
 * But we don't have time to bite off that much, first step is we now have the underlying menu
 *
 * so we can't possibly return a different answer :)
 */
// not used yet b/c it broke I can delete an apppointment from edit
// somehow causing an infinite loop in the relationship between AppointmentEditorDrawer and DrawerPage
// firing onLeaveHandler infinitely
export class DrawerStateV2 extends State<Record<string, never>> {
    private menu?: HTMLIonMenuElement;

    setIonMenu = (menu: HTMLIonMenuElement) => {
        this.menu = menu;
    };

    setOpen = (isOpen: boolean) => {
        this.setState({ });
    };

    isOpen = () => {
        return Boolean(this.menu?.isOpen());
    };
}
